import { BASE_URL } from "../../App";
import { SelectNormal, SelectSearch, MultipleSelect } from '../Reusable/SelectBox';
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import { Row, Col, Card } from 'antd';
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';
import ReceiptLongTwoToneIcon from '@mui/icons-material/ReceiptLongTwoTone';
import LocalPrintshopTwoToneIcon from '@mui/icons-material/LocalPrintshopTwoTone';
import LOGO from '../image/cri_logo.jpg';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormGroup, Stack, Backdrop, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, List, ListItem, ListItemText, Checkbox, Grid, FormControlLabel, Select, FormControl, MenuItem, InputLabel, OutlinedInput } from '@mui/material';

export default function PriceList() {
const login_id = localStorage.getItem("LOGIN_ID");
    const [isTermsAndConditionsOpen, setTermsAndConditionsOpen] = useState(false);
    const [isPrice_ListOpen, setPrice_list] = useState(false);
    const [branchlist, setBranch] = useState([]);
    const [categories, setCategories] = useState([]);
    const [region, setRegion] = useState([]);
    const [ItemList, setItemList] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [SelectedRegionCode, setSelectedRegionCode] = useState(null);
    const [SelectedSector, setSelectedSector] = useState([]);
    const [showCard, setShowCard] = useState(false);
    const [open, setOpen] = React.useState(false);
//    const login_id = localStorage.getItem("LOGIN_ID");
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [priceListData, setPriceListData] = useState(null);
    const [address, setAddress] = useState(null);

    const BRANCH_CODE = localStorage.getItem('BRANCH_CODE');
    const token = localStorage.getItem('Token');
    const headers = { Authorization: `Bearer ${token}` };

    const handleToggle = (value) => () => {
        const currentIndex = selectedItems.indexOf(value);
        const newSelectedItems = [...selectedItems];

        if (currentIndex === -1) {
            newSelectedItems.push(value);
        } else {
            newSelectedItems.splice(currentIndex, 1);
        }

        setSelectedItems(newSelectedItems);
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedItems([]);
        } else {
            const allItems = ItemList.map((item) => item.itemcode);
            setSelectedItems(allItems);
        }
        setSelectAll(!selectAll);
    };

    const handleClose = (isCheckboxChecked) => {
        if (isCheckboxChecked) {
            setTermsAndConditionsOpen(false);
        } else {
            const checkbox = document.getElementById('terms-checkbox');
            if (checkbox) {
                setTermsAndConditionsOpen(false);
                Swal.fire({
                    icon: "warning",
                    text: 'Please agree to the terms and conditions by checking the box.'
                }).then((result) => {
                    if (result.isConfirmed) {
                        setTermsAndConditionsOpen(true);
                        checkbox.focus();
                    }
                });
            }
        }
    };

    const handleClose1 = () => {
        setPrice_list(false);
    };

    useEffect(() => {
        BranchList();
        Categories();
        //RegionCode();
    }, []);

    const BranchList = () => {

        const data = { type: 'branch_list', branch_code: BRANCH_CODE,login_id: login_id};
        axios.post(BASE_URL + '/RcpPriceList', data).then(response => {
            if (response.status === 200) {
                setBranch(response.data.message);
            } else {
                Swal.fire({
                    icon: "warning",
                    text: 'Unexpected response status. Please try again.'
                });
            }
        })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            });
    };

    const Categories = () => {
        const data = { type: 'categories',login_id:login_id };

        axios.post(BASE_URL + '/RcpPriceList', data)
            .then(response => {
                if (response.status === 200) {
                    setCategories(response.data.message);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            });
    }
	 const RegionCode = (branch_code) => {
    // const RegionCode = () => {
        const data = { type: 'region_code', branch_code: branch_code,login_id:login_id  };
        //const data = { type: 'region_code', branch_code: BRANCH_CODE,login_id:login_id  };

        axios.post(BASE_URL + '/RcpPriceList', data)
            .then(response => {
                if (response.status === 200) {
                    setRegion(response.data.message);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            });
    }

    const Branch_List = branchlist ? branchlist.map((type) => ({
        Value: type.branch_code,
        Label: type.branch_name,
    })) : [];

    const REGION_CODE = region ? region.map((type) => ({
        Value: type.SAP_REGION,
        Label: `${type.SAP_REGION} - ${type.description}`,
    })) : [];

    const CATEGORIES = categories ? categories.map((type) => ({
        Value: type.matsubgroup_code,
        Label: type.description,
    })) : [];

    const Company = [
        { Value: "CRI", Label: "CRI" },
    ];

    const FetchPrictList = () => {

        if (!selectedBranch || !SelectedRegionCode || !SelectedSector) {
            Swal.fire({
                icon: "info",
                text: 'Please select values for all fields.'
            });
            return;
        }

        setOpen(true);
        const data = { type: 'Item_Select', branch_code: selectedBranch, item_sub_group: SelectedSector };
        axios.post(BASE_URL + '/RcpPriceList', data, { headers })
            .then(response => {
                if (response.status === 200) {
                    setItemList(response.data.message);
                    setTermsAndConditionsOpen(true);
                    setShowCard(true);
                    setOpen(false);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            });
    }

    const handlePriceList = () => {
        setOpen(true);
        const data = { type: 'Price_List', branch_code: selectedBranch, item_sub_group: SelectedSector, region_code: SelectedRegionCode, select_item: selectedItems };
        axios.post(BASE_URL + '/RcpPriceList', data, { headers })
            .then(response => {
                if (response.status === 200) {
                    setPriceListData(response.data.message); // Store API response data in state
                    setPrice_list(true);
                    setOpen(false);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            }).catch(error => {
                setOpen(false);
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            });

        const data1 = { type: 'Address', branch_code: selectedBranch };
        axios.post(BASE_URL + '/RcpPriceList', data1, { headers })
            .then(response => {
                if (response.status === 200) {
                    setAddress(response.data.message);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            }).catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            });
    };

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const handleChange = (event) => {
        const { target: { value }, } = event; setSelectedSector(typeof value === 'string' ? value.split(',') : value,);
    };
	
	const handleBranchChange = (newValue) => {
    setSelectedBranch(newValue); 
	console.log('dd',newValue);
	RegionCode(newValue);
  };


    return (
        <>
            <div className="container mt-5" style={{ justifyContent: 'center' }}>
                <div className='row'>
                    {/* <div className='col-md-3'>
                        <SelectSearch
                            label="Company"
                            required={true}
                            options={Company}
                            value={selectedCompany}
                            onChange={(newValue) => setSelectedCompany(newValue)}
                        />
				</div> */}
                    <div className='col-md-4'>
                        <SelectSearch
                            label="Branch"
                            required={true}
                            options={Branch_List}
                            value={selectedBranch}
                            //onChange={(newValue) => setSelectedBranch(newValue)}
                            onChange={handleBranchChange}
                        />
                    </div>
                    <div className='col-md-4'>
                        <SelectSearch
                            label="Region Code"
                            required={true}
                            options={REGION_CODE}
                            value={SelectedRegionCode}
                            onChange={(newValue) => setSelectedRegionCode(newValue)}
                        />
                    </div>
                    <div className='col-md-4'>
                        <FormControl fullWidth >
                            <InputLabel id="demo-multiple-checkbox-label">PSG</InputLabel>
                            <Select
                                fullWidth
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                value={SelectedSector}
                                onChange={handleChange}
                                input={<OutlinedInput label="PSG" />}
                                renderValue={(selected) => {
                                    const selectedDescriptions = categories
                                        .filter(type => selected.includes(type.matsubgroup_code))
                                        .map(type => type.description);
                                    return selectedDescriptions.join(', ');
                                }}
                                MenuProps={MenuProps}
                            >
                                {categories.map((type) => (
                                    <MenuItem key={type.matsubgroup_code} value={type.matsubgroup_code}>
                                        <Checkbox checked={SelectedSector.includes(type.matsubgroup_code)} />
                                        <ListItemText primary={type.description} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                    </div>
                </div>
                <br />
                <div className='row'>
                    <Button size="small" fullWidth variant="contained" endIcon={<ReceiptLongTwoToneIcon />} onClick={FetchPrictList}><b>Price List</b></Button>
                </div>
                <hr />
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
                    <CircularProgress color="inherit" />
                </Backdrop>
                {showCard ? (
                    <Card>
                        <center><b style={{ fontSize: '20px' }}>Item Selection</b></center><hr />
                        <List>
                            <ListItem disablePadding>
                                <FormControlLabel
                                    control={<Checkbox size="small" checked={selectAll} onChange={handleSelectAll} />}
                                    label="Select All"
                                />
                            </ListItem>
                            <Grid container spacing={1}>
                                {ItemList && ItemList.map((name) => (
                                    <Grid item xs={3} key={name.itemcode}>
                                        <ListItem disablePadding>
                                            <Checkbox
                                                size="small"
                                                checked={selectedItems.indexOf(name.itemcode) !== -1 || selectAll}
                                                onChange={handleToggle(name.itemcode)}
                                            />
                                            <ListItemText primary={name.description} />
                                        </ListItem>
                                    </Grid>
                                ))}
                            </Grid>
                        </List>

                        <center>
                            <br />
                            <Button size="small" fullWidth endIcon={<VisibilityTwoToneIcon />} variant="contained" onClick={handlePriceList} >
                                <span><b>View Price List</b></span>
                            </Button>
                        </center>
                    </Card>
                ) : (
                    <Card style={{
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                        borderRadius: '10px',
                    }}>
                        <center>
                            <span>Please Select All Fields</span>
                        </center>
                    </Card>
                )}
                {isTermsAndConditionsOpen && (
                    <TERMSANDCONDITIONS onClose={handleClose} />
                )}
                {isPrice_ListOpen && (
                    <PRICE_LIST onClose={handleClose1} priceListData={priceListData} Address={address} />
                )}
            </div>
        </>
    );
};

const TERMSANDCONDITIONS = ({ onClose }) => {

    const [isCheckboxChecked, setCheckboxChecked] = useState(false);
    const [termsData, setTermsData] = useState([]);

    useEffect(() => {
        const data = { type: 'terms_and_conditions' };

        axios.post(BASE_URL + '/RcpPriceList', data)
            .then(response => {
                if (response.status === 200) {
                    setTermsData(response.data.message);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            });

    }, []);

    const handleBackdropClick = (event) => {
        event.stopPropagation();
    };

    const handleCheckboxChange = (event) => {
        setCheckboxChecked(event.target.checked);
    };

    const handleDialogClose = (event, reason) => {
        onClose(isCheckboxChecked);
    };

    return (
        <Dialog
            open={true}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            sx={{ justifyContent: 'center' }}
            onClick={handleBackdropClick}
        >

            <DialogTitle><u><b>TERMS AND CONDITIONS</b></u></DialogTitle>
            <DialogContent>
                <ol>
                    {termsData.map((term, index) => (
                        <li key={index}>{term.TERMS}</li>
                    ))}
                </ol>
                <FormGroup>
                    <FormControlLabel
                        control={<Checkbox id="terms-checkbox" checked={isCheckboxChecked} onChange={handleCheckboxChange} />}
                        label="I Agree"
                    />
                </FormGroup>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center' }}>
                <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
                    <Button
                        onClick={handleDialogClose}
                        variant="outlined"
                        fullWidth
                        width="400px"
                    >
                        Close
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};

const PRICE_LIST = ({ onClose, priceListData, Address }) => {
    const [TaC, setSelectedItemsTermsAndConditions] = useState([]);

    useEffect(() => {
        const data = { type: 'item_terms_and_conditions' };
        axios.post(BASE_URL + '/RcpPriceList', data)
            .then(response => {
                setSelectedItemsTermsAndConditions(response.data.message);
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            });
    }, []);

    const handleDialogClose = () => {
        onClose();
    };

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            console.error("Failed to open print window");
            return;
        }

        const addressHTML = Address.map((row) => `
            <li><center>${row.Branchname}, ${row.Address},<br/> ${row.city} - ${row.pincode}</center></li>
        `).join('');

        const tableRows = priceListData.map((row, index) => `
            <tr>
                <td>${row.itemcode}</td>
                <td>${row.itemdescription}</td>
                <td>${row.HSN_CODE}</td>
                <td>${row.HP}</td>
                <td>${row.HeadRangeMin !== null ? row.HeadRangeMin : '-'}</td>
                <td>${row.HeadRangeMax !== null ? row.HeadRangeMax : '-'}</td>
                <td>${row.FlowMax !== null ? row.FlowMax : '-'}</td>
                <td>${row.FlowMin !== null ? row.FlowMin : '-'}</td>
                 <td>${row.ListRate !== null ? row.ListRate : '-'}</td>
                <td>${row.RCPPrice !== null ? row.RCPPrice : '-'}</td>
               
            </tr>
        `).join('');

        const termsHTML = TaC.map((row) => `<li>${row.TERMS}</li>`).join('');

        printWindow.document.write(`
            <!DOCTYPE html>
            <html lang="en">
            <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>RCP PRICE LIST</title>
                <style>
                    body { font-family: Arial, sans-serif; }
                    table { border-collapse: collapse; width: 100%; }
                    th, td { border: 1px solid #ddd; padding: 8px; }
                    th { background-color: #f2f2f2; }
                    h2, h3 { text-align: center; }
                    ul { list-style-type: none; padding: 0; }
                </style>
            </head>
            <body>
                <center>
                    <u><b style={{ fontSize: '20px' }}>C.R.I. PUMPS PRIVATE LIMITED</b></u><br />
                    <ul style={{ listStyleType: 'none' }}>
                        <li className="text-muted" style={{ fontSize: '16px' }}>CORPORATE OFFICE, 7/46-1 ,KEERANATHAM ROAD,</li>
                        <li className="text-muted" style={{ fontSize: '16px' }}>SARAVANAMPATTY, COIMBATORE - 641035.</li>
                    </ul>
                </center>
                <br/>
                <h3>PRICE LIST (CONFIDENTIAL DOCUMENT)</h3>
                <ul>${addressHTML}</ul>
                <table>
                    <thead>
                        <tr>
                            <th>Item Code</th>
                            <th>Item Description</th>
                            <th>HSN Code</th>
                            <th>H.P</th>
                            <th>Mtr (Min)</th>
                            <th>Mtr (Max)</th>
                            <th>LPS (Max)</th>
                            <th>LPS (Min)</th>
                            <th>LP in ₹ (GST)</th>
                            <th>RCP Price in ₹ (GST)</th>
                        </tr>
                    </thead>
                    <tbody>${tableRows}</tbody>
                </table>
                <h3>TERMS AND CONDITIONS</h3>
                <ol>${termsHTML}</ol>
            </body>
            </html>
        `);

        printWindow.document.close();
        printWindow.print();
        printWindow.close();
    };

    return (
        <Dialog open={true} onClose={onClose} fullWidth maxWidth="xl">
            <DialogTitle>
                <div className="row">
                    <div className="col-md-3"></div>
                    <div className="col-md-6 text-center">
                        <center>
                            <u><b style={{ fontSize: '20px' }}>C.R.I. PUMPS PRIVATE LIMITED</b></u><br />
                            <ul style={{ listStyleType: 'none' }}>
                                <li className="text-muted" style={{ fontSize: '16px' }}>CORPORATE OFFICE, 7/46-1 ,KEERANATHAM ROAD,</li>
                                <li className="text-muted" style={{ fontSize: '16px' }}>SARAVANAMPATTY, COIMBATORE - 641035.</li>
                            </ul>
                        </center>
                    </div>
                    <div className="col-md-3">
                        <center>
                            <span>
                                <img src={LOGO} alt={"logo"} style={{ borderRadius: '50%', height: '60px', width: '60px' }} />
                            </span>
                        </center>
                    </div>
                </div>
            </DialogTitle>
            <DialogContent id="print-content">
                <center>
                    <b>
                        <u>PRICE LIST</u> <br />
                        (CONFIDENTIAL DOCUMENT)
                    </b>
                    <br />
                    <ul style={{ listStyleType: 'none' }}>
                        {Address.map((row, index) => (
                            <>
                                <li class="text-muted">{row.Branchname},{row.Address}</li>
                                <li class="text-muted">{row.city}-{row.pincode}</li>
                            </>
                        ))}
                    </ul>
                </center>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 800 }} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#1bb01be0' }}>
                                <TableCell align="right">PSG</TableCell>
                                <TableCell align="right">Item Code</TableCell>
                                <TableCell align="right">Item Description</TableCell>
                                <TableCell align="right">HSN Code</TableCell>
                                <TableCell align="right">H.P</TableCell>
                                <TableCell align="right">Mtr(Min)</TableCell>
                                <TableCell align="right">Mtr(Max)</TableCell>
                                <TableCell align="right">LPS (Max)</TableCell>
                                <TableCell align="right">LPS (Min)</TableCell>
                                <TableCell align="right">LP in ₹ (GST)</TableCell>
                                <TableCell align="right">RCP Price in ₹ (GST)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {priceListData.map((row, index) => (
                                <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell align="right">{row.itemproductsubgroup}</TableCell>
                                    <TableCell align="right">{row.itemcode}</TableCell>
                                    <TableCell align="right">{row.itemdescription}</TableCell>
                                    <TableCell align="right">{row.HSN_CODE}</TableCell>
                                    <TableCell align="right">{row.HP}</TableCell>
                                    <TableCell align="right">{row.HeadRangeMax}</TableCell>
                                    <TableCell align="right">{row.HeadRangeMin}</TableCell>
                                    <TableCell align="right">{row.FlowMax}</TableCell>
                                    <TableCell align="right">{row.FlowMin}</TableCell>
                                    <TableCell align="right">{row.ListRate}</TableCell>
                                    <TableCell align="right">{row.RCPPrice}</TableCell>
                                   
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <li className="mt-4 text-muted">Refer our performance chart for correct selection of pumps.</li>
                <br />
                <b><u>TERMS AND CONDITIONS</u></b>
                <ol>
                    {TaC.map((row, index) => (
                        <li className="text-muted">{row.TERMS}</li>
                    ))}
                </ol>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center' }}>
                <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '900px' }}>
                    <Button
                        // onClick={() => window.print()}
                        onClick={handlePrint}
                        variant="outlined"
                        fullWidth
                        endIcon={<LocalPrintshopTwoToneIcon />}
                    >
                        Print
                    </Button>
                    <Button
                        onClick={handleDialogClose}
                        variant="outlined"
                        fullWidth
                        color="error"
                    >
                        Close
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};